export default __webpack_public_path__ + "static/media/headerImage.e631c5a9.png";